/**
 * @license
 * @copyright Copyright Motili Inc., 2023 All Rights Reserved
 */

import { Heading1, Paragraph } from '@motili/ui';
import { ReactElement } from 'react';
import { styled } from 'styled-components';
import CenteredContainer from '../../../components/layout/CenteredContainer';
import StyledButton from '../../../components/styled/StyledButton';

export default function RegistrationComplete(): ReactElement {
    return (
        <CenteredContainer>
            <Heading1>Registration Complete!</Heading1>
            <Paragraph>Thank you for registering with Motili.</Paragraph>
            <Paragraph>
                We are excited at the possibility to work together. Your account
                details are below but we have also sent you a confirmation email
                so you know what to expect. If you have any questions please fee
                free to contact us. Otherwise we will notify you when your
                account is complete and what happens next.
            </Paragraph>
            <StyledLink href='https://www.motili.com/'>
                <StyledButton variant='primary' onClick={() => {}}>
                    Visit Motili Website
                </StyledButton>
            </StyledLink>
        </CenteredContainer>
    );
}

const StyledLink = styled.a`
    width: 100%;
    margin-top: 30px;

    & > button {
        width: 100%;
    }
`;
